export default "__VITE_ASSET__Dn3lj5I$__"